// =========================================================
// Global Helper Functions (Exposed immediately on window)
// =========================================================

window.adjustCardQty = function(btnElem, delta) {
    const container = btnElem.closest('.qty-control');
    if (!container) return;
    const input = container.querySelector('.qty-input');
    if (!input) return;
    let val = parseInt(input.value) || 1;
    val += delta;
    if (val < 1) val = 1;
    input.value = val;
};

window.adjustQty = function(amount, btnElem) {
    let qtyInput = null;
    if (btnElem) {
        const container = btnElem.closest('.qty-control');
        if (container) qtyInput = container.querySelector('.qty-input');
    }
    if (!qtyInput) {
        qtyInput = document.querySelector('.product-details-container .qty-input') || document.querySelector('.qty-input');
    }

    if (qtyInput) {
        let current = parseInt(qtyInput.value) || 1;
        current += amount;
        if (current < 1) current = 1;
        qtyInput.value = current;
    }
};

window.changeMainImage = function(src, thumbElem) {
    const mainImg = document.getElementById('main-product-image');
    if (mainImg) {
        mainImg.src = src;
    }
    document.querySelectorAll('.thumb-item').forEach(t => t.classList.remove('active'));
    if (thumbElem) {
        thumbElem.classList.add('active');
    }
};

window.updateCartItemQty = function(btnElem, delta) {
    const cartItem = btnElem.closest('.cart-item');
    if (!cartItem) return;

    const input = cartItem.querySelector('.cart-qty-input');
    if (!input) return;

    let currentQty = parseInt(input.value) || 0;
    let newQty = currentQty + delta;
    if (newQty < 0) newQty = 0;

    input.value = newQty;
    processCartQtyChange(cartItem, input, newQty);
};

window.onCartQtyInputChange = function(inputElem) {
    const cartItem = inputElem.closest('.cart-item');
    if (!cartItem) return;

    let newQty = parseInt(inputElem.value) || 0;
    if (newQty < 0) newQty = 0;
    inputElem.value = newQty;

    processCartQtyChange(cartItem, inputElem, newQty);
};

window.removeCartItem = function(btnElem, lineIndex, itemKey) {
    const cartItem = btnElem.closest('.cart-item');
    if (!cartItem) return;

    const input = cartItem.querySelector('.cart-qty-input');
    if (input) input.value = 0;

    processCartQtyChange(cartItem, input, 0);
};

window.handleBuyNow = function(form) {
    if (!form) return;
    const formData = new FormData(form);
    fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json'
        }
    })
    .then(() => {
        window.location.href = '/checkout';
    })
    .catch(() => {
        form.action = '/cart/add?return_to=/checkout';
        form.submit();
    });
};

function processCartQtyChange(cartItem, inputElem, newQty) {
    const lineIndex = inputElem ? inputElem.dataset.line : cartItem.dataset.line;

    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            line: parseInt(lineIndex),
            quantity: newQty
        })
    })
    .then(res => {
        if (!res.ok) throw new Error('Shopify API update failed');
        return res.json();
    })
    .then(cart => {
        updateCartFromShopifyResponse(cart);
    })
    .catch(() => {
        // Local client-side fallback for static preview / offline dev
        updateCartLocalDOM(cartItem, newQty);
    });
}

function updateCartLocalDOM(cartItem, newQty) {
    const unitPrice = parseFloat(cartItem.dataset.unitPrice) || 0;

    if (newQty === 0) {
        cartItem.style.opacity = '0';
        cartItem.style.transform = 'translateY(-10px)';
        setTimeout(() => {
            cartItem.remove();
            recalculateCartTotals();
        }, 300);
    } else {
        const linePrice = unitPrice * newQty;
        const linePriceElem = cartItem.querySelector('.cart-item-price');
        if (linePriceElem) {
            linePriceElem.dataset.linePrice = linePrice;
            linePriceElem.textContent = formatMoney(linePrice);
        }
        recalculateCartTotals();
    }
}

function updateCartFromShopifyResponse(cart) {
    const badgeElem = document.getElementById('cart-count');
    if (badgeElem) badgeElem.textContent = cart.item_count;

    const totalElem = document.getElementById('cart-total-price');
    if (totalElem) totalElem.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
        renderEmptyCartState();
    } else {
        cart.items.forEach((item, idx) => {
            const linePriceElem = document.getElementById(`line-price-${idx + 1}`);
            if (linePriceElem) {
                linePriceElem.textContent = formatMoney(item.final_line_price);
            }
        });
    }
}

function recalculateCartTotals() {
    const remainingItems = document.querySelectorAll('.cart-item');
    let totalCents = 0;
    let totalCount = 0;

    remainingItems.forEach(item => {
        const input = item.querySelector('.cart-qty-input');
        const qty = input ? (parseInt(input.value) || 0) : 0;
        const unitPrice = parseFloat(item.dataset.unitPrice) || 0;

        totalCount += qty;
        totalCents += (qty * unitPrice);

        const linePriceElem = item.querySelector('.cart-item-price');
        if (linePriceElem) {
            linePriceElem.textContent = formatMoney(qty * unitPrice);
        }
    });

    const totalElem = document.getElementById('cart-total-price');
    if (totalElem) {
        totalElem.textContent = formatMoney(totalCents);
    }

    const badgeElem = document.getElementById('cart-count');
    if (badgeElem) {
        badgeElem.textContent = totalCount;
    }

    if (totalCount === 0 || remainingItems.length === 0) {
        renderEmptyCartState();
    }
}

function renderEmptyCartState() {
    const cartForm = document.querySelector('.cart-form');
    const cartPage = document.querySelector('.cart-page');

    if (cartForm) cartForm.style.display = 'none';

    let emptyMsg = document.getElementById('empty-cart-msg');
    let continueBox = document.getElementById('continue-shopping-box');

    const currentLanguage = localStorage.getItem('site_theme_lang') || 'it';
    const TRANSLATIONS = window.TRANSLATIONS_MAP || {};

    if (!emptyMsg && cartPage) {
        const dictionary = TRANSLATIONS[currentLanguage] || TRANSLATIONS.it || {};
        const emptyHTML = `
            <div class="empty-cart-msg" id="empty-cart-msg" data-i18n="empty_cart">${dictionary.empty_cart || 'Il tuo carrello è attualmente vuoto.'}</div>
            <div style="text-align: center; margin-top: 20px;" id="continue-shopping-box">
                <a href="/" class="btn btn-secondary" data-i18n="continue_shopping">${dictionary.continue_shopping || 'Continua lo Shopping'}</a>
            </div>
        `;
        cartPage.insertAdjacentHTML('beforeend', emptyHTML);
    } else {
        if (emptyMsg) emptyMsg.style.display = 'block';
        if (continueBox) continueBox.style.display = 'block';
    }
}

function formatMoney(cents) {
    return '$' + (Number(cents || 0) / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

function isVariantAvailable(variant) {
    if (!variant) return false;

    // `available` is the value calculated by Shopify and is authoritative when
    // present. In particular, do not override `false` with inventory_quantity:
    // it can be stale or unavailable to the storefront.
    if (typeof variant.available === 'boolean') return variant.available;

    // Fallback only for incomplete data returned by a static/theme preview.
    if (variant.inventory_policy === 'continue') return true;
    if (variant.inventory_management == null) return true;

    const quantity = Number(variant.inventory_quantity);
    return Number.isFinite(quantity) && quantity > 0;
}

// =========================================================
// DOM Ready Event Initialization
// =========================================================

document.addEventListener('DOMContentLoaded', function() {
    // 1. Language Selector & Full Site Translation Logic
    const TRANSLATIONS = {
        it: {
            search_placeholder: "Cerca prodotti...",
            cart_heading: "Il tuo Carrello",
            empty_cart: "Il tuo carrello è attualmente vuoto.",
            continue_shopping: "Continua lo Shopping",
            total: "Totale:",
            proceed_checkout: "Procedi al Checkout",
            remove: "Rimuovi",
            add_to_cart: "🛒 Aggiungi al Carrello",
            buy_now: "⚡ Acquista Ora",
            out_of_stock: "Esaurito",
            in_stock: "Disponibile",
            quantity: "Quantità:",
            toast_added: "Articolo aggiunto al carrello! 🛒",
            catalog_heading: "Tutti i Prodotti",
            variants_available: "varianti disponibili",
            back_to_catalog: "Torna al Catalogo",
            no_products: "Nessun prodotto trovato.",
            // Badges
            badge_sale: "IN OFFERTA",
            badge_hyperdrip: "HYPERDRIP",
            badge_new: "NOVITÀ",
            // Ad Banner
            ad_badge: "VANTAGGI ESCLUSIVI",
            ad_title: "✨ Scopri prodotti esclusivi scelti per te",
            ad_subtitle: "Qualità premium, pagamenti sicuri e assistenza dedicata.",
            ad_button: "Esplora Ora",
            // Hero & Descriptions
            hero_default_desc: "Scopri la nostra collezione esclusiva di prodotti premium ad alte prestazioni.",
            // Footer
            footer_desc: "Il tuo store digitale di riferimento per prodotti esclusivi, innovativi e ad alte prestazioni. Spedizione rapida e supporto 24/7.",
            footer_nav_title: "Navigazione",
            footer_support_title: "Assistenza Clienti",
            footer_newsletter_title: "Rimani Aggiornato",
            footer_newsletter_sub: "Iscriviti alla newsletter per sconti esclusivi e anteprime.",
            footer_newsletter_placeholder: "Inserisci la tua email...",
            footer_subscribe_btn: "Iscriviti",
            footer_copyright: "Tutti i diritti riservati.",
            footer_shipping: "Spedizioni e Consegne",
            footer_returns: "Resi e Rimborsi",
            footer_faq: "Domande Frequenti (FAQ)",
            footer_privacy: "Privacy Policy",
            nav_home: "Home",
            nav_catalog: "Catalogo Prodotti",
            nav_cart: "Carrello",
            // Swatches & Options
            opt_color: "Colore",
            opt_size: "Taglia",
            val_red: "Rosso",
            val_blue: "Blu",
            val_black: "Nero",
            val_white: "Bianco",
            val_green: "Verde",
            val_small: "Piccola (S)",
            val_medium: "Media (M)",
            val_large: "Grande (L)"
        },
        en: {
            search_placeholder: "Search products...",
            cart_heading: "Your Shopping Cart",
            empty_cart: "Your cart is currently empty.",
            continue_shopping: "Continue Shopping",
            total: "Total:",
            proceed_checkout: "Proceed to Checkout",
            remove: "Remove",
            add_to_cart: "🛒 Add to Cart",
            buy_now: "⚡ Buy Now",
            out_of_stock: "Out of Stock",
            in_stock: "In Stock",
            quantity: "Quantity:",
            toast_added: "Item added to cart! 🛒",
            catalog_heading: "All Products",
            variants_available: "variants available",
            back_to_catalog: "Back to Catalog",
            no_products: "No products found.",
            // Badges
            badge_sale: "ON SALE",
            badge_hyperdrip: "HYPERDRIP",
            badge_new: "NEW ARRIVAL",
            // Ad Banner
            ad_badge: "EXCLUSIVE BENEFITS",
            ad_title: "✨ Discover exclusive products selected for you",
            ad_subtitle: "Premium quality, secure payments and dedicated support.",
            ad_button: "Explore Now",
            // Hero & Descriptions
            hero_default_desc: "Discover our exclusive collection of high-performance premium products.",
            // Footer
            footer_desc: "Your premier digital store for exclusive, high-performance products. Fast shipping & 24/7 support.",
            footer_nav_title: "Navigation",
            footer_support_title: "Customer Care",
            footer_newsletter_title: "Stay Updated",
            footer_newsletter_sub: "Subscribe to our newsletter for exclusive discounts and previews.",
            footer_newsletter_placeholder: "Enter your email...",
            footer_subscribe_btn: "Subscribe",
            footer_copyright: "All rights reserved.",
            footer_shipping: "Shipping & Delivery",
            footer_returns: "Returns & Refunds",
            footer_faq: "Frequently Asked Questions",
            footer_privacy: "Privacy Policy",
            nav_home: "Home",
            nav_catalog: "Product Catalog",
            nav_cart: "Shopping Cart",
            // Swatches & Options
            opt_color: "Color",
            opt_size: "Size",
            val_red: "Red",
            val_blue: "Blue",
            val_black: "Black",
            val_white: "White",
            val_green: "Green",
            val_small: "Small (S)",
            val_medium: "Medium (M)",
            val_large: "Large (L)"
        },
        fr: {
            search_placeholder: "Rechercher des produits...",
            cart_heading: "Votre Panier",
            empty_cart: "Votre panier est actuellement vide.",
            continue_shopping: "Continuer vos achats",
            total: "Total:",
            proceed_checkout: "Passer la commande",
            remove: "Supprimer",
            add_to_cart: "🛒 Ajouter au panier",
            buy_now: "⚡ Acheter maintenant",
            out_of_stock: "Rupture de stock",
            in_stock: "En stock",
            quantity: "Quantité:",
            toast_added: "Article ajouté au panier ! 🛒",
            catalog_heading: "Tous les produits",
            variants_available: "variantes disponibles",
            back_to_catalog: "Retour au catalogue",
            no_products: "Aucun produit trouvé.",
            // Badges
            badge_sale: "EN PROMOTION",
            badge_hyperdrip: "HYPERDRIP",
            badge_new: "NOUVEAUTÉ",
            // Ad Banner
            ad_badge: "AVANTAGES EXCLUSIFS",
            ad_title: "✨ Découvrez des produits exclusifs sélectionnés pour vous",
            ad_subtitle: "Qualité premium, paiements sécurisés et assistance dédiée.",
            ad_button: "Découvrir",
            // Hero & Descriptions
            hero_default_desc: "Découvrez notre collection exclusive de produits haut de gamme et performants.",
            // Footer
            footer_desc: "Votre boutique en ligne de référence pour des produits exclusifs et performants. Livraison rapide et support 24/7.",
            footer_nav_title: "Navigation",
            footer_support_title: "Service Client",
            footer_newsletter_title: "Restez Informé",
            footer_newsletter_sub: "Abonnez-vous à la newsletter pour des réductions exclusives et des avant-premières.",
            footer_newsletter_placeholder: "Entrez votre e-mail...",
            footer_subscribe_btn: "S'abonner",
            footer_copyright: "Tous droits réservés.",
            footer_shipping: "Expédition et Livraison",
            footer_returns: "Retours et Remboursements",
            footer_faq: "Foire Aux Questions (FAQ)",
            footer_privacy: "Politique de Confidentialité",
            nav_home: "Accueil",
            nav_catalog: "Catalogue Produits",
            nav_cart: "Panier",
            // Swatches & Options
            opt_color: "Couleur",
            opt_size: "Taille",
            val_red: "Rouge",
            val_blue: "Bleu",
            val_black: "Noir",
            val_white: "Blanc",
            val_green: "Vert",
            val_small: "Petite (S)",
            val_medium: "Moyenne (M)",
            val_large: "Grande (L)"
        },
        es: {
            search_placeholder: "Buscar productos...",
            cart_heading: "Tu Carrito de Compras",
            empty_cart: "Tu carrito está vacío.",
            continue_shopping: "Seguir comprando",
            total: "Total:",
            proceed_checkout: "Proceder al Pago",
            remove: "Eliminar",
            add_to_cart: "🛒 Añadir al Carrito",
            buy_now: "⚡ Comprar Ahora",
            out_of_stock: "Agotado",
            in_stock: "En stock",
            quantity: "Cantidad:",
            toast_added: "¡Artículo añadido al carrito! 🛒",
            catalog_heading: "Todos los productos",
            variants_available: "variantes disponibles",
            back_to_catalog: "Volver al catálogo",
            no_products: "No se encontraron productos.",
            // Badges
            badge_sale: "EN OFERTA",
            badge_hyperdrip: "HYPERDRIP",
            badge_new: "NOVEDAD",
            // Ad Banner
            ad_badge: "VENTAJAS EXCLUSIVAS",
            ad_title: "✨ Descubre productos exclusivos seleccionados para ti",
            ad_subtitle: "Calidad premium, pagos seguros y asistencia dedicada.",
            ad_button: "Explorar ahora",
            // Hero & Descriptions
            hero_default_desc: "Descubre nuestra colección exclusiva de productos de alto rendimiento.",
            // Footer
            footer_desc: "Tu tienda digital de referencia para productos exclusivos y de alto rendimiento. Envío rápido y soporte 24/7.",
            footer_nav_title: "Navegación",
            footer_support_title: "Atención al Cliente",
            footer_newsletter_title: "Mantente Actualizado",
            footer_newsletter_sub: "Suscríbete al boletín para descuentos exclusivos y adelantos.",
            footer_newsletter_placeholder: "Introduce tu correo...",
            footer_subscribe_btn: "Suscribirse",
            footer_copyright: "Todos los derechos reservados.",
            footer_shipping: "Envíos y Entregas",
            footer_returns: "Devoluciones y Reembolsos",
            footer_faq: "Preguntas Frecuentes (FAQ)",
            footer_privacy: "Política de Privacidad",
            nav_home: "Inicio",
            nav_catalog: "Catálogo de Productos",
            nav_cart: "Carrito de Compras",
            // Swatches & Options
            opt_color: "Color",
            opt_size: "Talla",
            val_red: "Rojo",
            val_blue: "Azul",
            val_black: "Negro",
            val_white: "Blanco",
            val_green: "Verde",
            val_small: "Pequeña (S)",
            val_medium: "Mediana (M)",
            val_large: "Grande (L)"
        },
        de: {
            search_placeholder: "Produkte suchen...",
            cart_heading: "Ihr Warenkorb",
            empty_cart: "Ihr Warenkorb ist derzeit leer.",
            continue_shopping: "Weiter einkaufen",
            total: "Gesamt:",
            proceed_checkout: "Zur Kasse",
            remove: "Entfernen",
            add_to_cart: "🛒 In den Warenkorb",
            buy_now: "⚡ Jetzt kaufen",
            out_of_stock: "Ausverkauft",
            in_stock: "Auf Lager",
            quantity: "Menge:",
            toast_added: "Artikel zum Warenkorb hinzugefügt! 🛒",
            catalog_heading: "Alle Produkte",
            variants_available: "Varianten verfügbar",
            back_to_catalog: "Zurück zum Katalog",
            no_products: "Keine Produkte gefunden.",
            // Badges
            badge_sale: "IM ANGEBOT",
            badge_hyperdrip: "HYPERDRIP",
            badge_new: "NEU",
            // Ad Banner
            ad_badge: "EXKLUSIVE VORTEILE",
            ad_title: "✨ Entdecken Sie exklusive, ausgewählte Produkte",
            ad_subtitle: "Premium-Qualität, sichere Zahlungen und persönlicher Support.",
            ad_button: "Jetzt entdecken",
            // Hero & Descriptions
            hero_default_desc: "Entdecken Sie unsere exklusive Kollektion von High-Performance-Premium-Produkten.",
            // Footer
            footer_desc: "Ihr führender Digital-Store für exklusive High-Performance-Produkte. Schneller Versand & 24/7-Support.",
            footer_nav_title: "Navigation",
            footer_support_title: "Kundenservice",
            footer_newsletter_title: "Bleiben Sie Informiert",
            footer_newsletter_sub: "Abonnieren Sie den Newsletter für exklusive Rabatte und Vorschauen.",
            footer_newsletter_placeholder: "E-Mail-Adresse eingeben...",
            footer_subscribe_btn: "Abonnieren",
            footer_copyright: "Alle Rechte vorbehalten.",
            footer_shipping: "Versand & Lieferung",
            footer_returns: "Rückgabe & Erstattung",
            footer_faq: "Häufige Fragen (FAQ)",
            footer_privacy: "Datenschutz",
            nav_home: "Startseite",
            nav_catalog: "Produktkatalog",
            nav_cart: "Warenkorb",
            // Swatches & Options
            opt_color: "Farbe",
            opt_size: "Größe",
            val_red: "Rot",
            val_blue: "Blau",
            val_black: "Schwarz",
            val_white: "Weiß",
            val_green: "Grün",
            val_small: "Klein (S)",
            val_medium: "Mittel (M)",
            val_large: "Groß (L)"
        }
    };

    window.TRANSLATIONS_MAP = TRANSLATIONS;

    const LANG_FLAGS = {
        it: { flag: '🇮🇹', code: 'IT' },
        en: { flag: '🇬🇧', code: 'EN' },
        fr: { flag: '🇫🇷', code: 'FR' },
        es: { flag: '🇪🇸', code: 'ES' },
        de: { flag: '🇩🇪', code: 'DE' }
    };

    let currentLanguage = localStorage.getItem('site_theme_lang') || 'it';

    function setLanguage(lang) {
        if (!TRANSLATIONS[lang]) lang = 'it';
        currentLanguage = lang;
        localStorage.setItem('site_theme_lang', lang);

        // Update Flag Dot & Code in Header
        const currentFlagDot = document.getElementById('current-flag-dot');
        const currentLangCode = document.getElementById('current-lang-code');
        if (currentFlagDot && LANG_FLAGS[lang]) {
            currentFlagDot.innerHTML = `<span class="flag-icon">${LANG_FLAGS[lang].flag}</span>`;
        }
        if (currentLangCode && LANG_FLAGS[lang]) {
            currentLangCode.textContent = LANG_FLAGS[lang].code;
        }

        // Update Active Option in Dropdown
        document.querySelectorAll('.lang-option').forEach(opt => {
            if (opt.dataset.lang === lang) {
                opt.classList.add('active');
            } else {
                opt.classList.remove('active');
            }
        });

        // Translate Text Content (data-i18n)
        const dictionary = TRANSLATIONS[lang];
        document.querySelectorAll('[data-i18n]').forEach(elem => {
            const key = elem.dataset.i18n;
            if (dictionary[key]) {
                elem.textContent = dictionary[key];
            }
        });

        // Translate Placeholders (data-i18n-placeholder)
        document.querySelectorAll('[data-i18n-placeholder]').forEach(elem => {
            const key = elem.dataset.i18nPlaceholder;
            if (dictionary[key]) {
                elem.placeholder = dictionary[key];
            }
        });

        // Translate Option Labels (data-i18n-option)
        document.querySelectorAll('[data-i18n-option]').forEach(elem => {
            const name = elem.dataset.i18nOption.toLowerCase();
            if (name.includes('color') || name.includes('colore')) {
                elem.textContent = dictionary.opt_color;
            } else if (name.includes('size') || name.includes('taglia')) {
                elem.textContent = dictionary.opt_size;
            }
        });

        // Translate Option Values (data-i18n-val)
        document.querySelectorAll('[data-i18n-val]').forEach(elem => {
            const val = elem.dataset.i18nVal.toLowerCase();
            if (val === 'red' || val === 'rosso' || val === 'rouge' || val === 'rojo' || val === 'rot') elem.textContent = dictionary.val_red;
            else if (val === 'blue' || val === 'blu' || val === 'bleu' || val === 'azul' || val === 'blau') elem.textContent = dictionary.val_blue;
            else if (val === 'black' || val === 'nero' || val === 'noir' || val === 'negro' || val === 'schwarz') elem.textContent = dictionary.val_black;
            else if (val === 'white' || val === 'bianco' || val === 'blanc' || val === 'blanco' || val === 'weiß') elem.textContent = dictionary.val_white;
            else if (val === 'green' || val === 'verde' || val === 'vert' || val === 'grün') elem.textContent = dictionary.val_green;
            else if (val === 's' || val === 'small') elem.textContent = dictionary.val_small;
            else if (val === 'm' || val === 'medium') elem.textContent = dictionary.val_medium;
            else if (val === 'l' || val === 'large') elem.textContent = dictionary.val_large;
        });

        // Translate Product & Promo Descriptions (data-i18n-desc)
        const descTranslationsMap = {
            "Discover the great features of this exclusive product.": {
                it: "Scopri le straordinarie caratteristiche e il design premium di questo prodotto esclusivo.",
                en: "Discover the extraordinary features and premium design of this exclusive product.",
                fr: "Découvrez les caractéristiques exceptionnelles et le design premium de ce produit exclusif.",
                es: "Descubre las increíbles características y el diseño exclusivo de este producto.",
                de: "Entdecken Sie die herausragenden Funktionen und das erstklassige Design dieses exklusiven Produkts."
            },
            "Scopri le straordinarie caratteristiche e il design premium di questo prodotto esclusivo.": {
                it: "Scopri le straordinarie caratteristiche e il design premium di questo prodotto esclusivo.",
                en: "Discover the extraordinary features and premium design of this exclusive product.",
                fr: "Découvrez les caractéristiques exceptionnelles et le design premium de ce produit exclusif.",
                es: "Descubre las increíbles características y el diseño exclusivo de este producto.",
                de: "Entdecken Sie die herausragenden Funktionen und das erstklassige Design dieses exklusiven Produkts."
            },
            "Prodotto premium Hyperdrip realizzato con materiali di elevata qualità, finiture curate ed eccellente comfort per uno stile unico.": {
                it: "Prodotto premium Hyperdrip realizzato con materiali di elevata qualità, finiture curate ed eccellente comfort per uno stile unico.",
                en: "Hyperdrip premium product crafted with high quality materials, refined details, and excellent comfort for a unique style.",
                fr: "Produit haut de gamme Hyperdrip conçu avec des matériaux de qualité supérieure, un confort exceptionnel et un style unique.",
                es: "Producto premium Hyperdrip elaborado con materiales de alta calidad, excelente comodidad y un estilo exclusivo.",
                de: "Hyperdrip Premium-Produkt aus hochwertigen Materialien, hervorragendem Komfort und exklusivem Stil."
            },
            "Scopri la nostra collezione esclusiva.": {
                it: "Scopri la nostra collezione esclusiva di articoli ad alte prestazioni.",
                en: "Discover our exclusive collection of high-performance items.",
                fr: "Découvrez notre collection exclusive d'articles haute performance.",
                es: "Descubre nuestra colección exclusiva de prendas de alto rendimiento.",
                de: "Entdecken Sie unsere exklusive Kollektion von High-Performance-Artikeln."
            },
            "Scopri la nostra collezione esclusiva di prodotti premium ad alte prestazioni.": {
                it: "Scopri la nostra collezione esclusiva di prodotti premium ad alte prestazioni.",
                en: "Discover our exclusive collection of high-performance premium products.",
                fr: "Découvrez notre collection exclusive de produits haut de gamme et performants.",
                es: "Descubre nuestra colección exclusiva de productos premium de alto rendimiento.",
                de: "Entdecken Sie unsere exklusive Kollektion von High-Performance-Premium-Produkten."
            }
        };

        const phraseReplacements = {
            en: [
                [ /scopri le straordinarie caratteristiche/gi, "discover the extraordinary features" ],
                [ /design premium/gi, "premium design" ],
                [ /prodotto esclusivo/gi, "exclusive product" ],
                [ /prodotto premium hyperdrip/gi, "Hyperdrip premium product" ],
                [ /materiali di elevata qualità/gi, "high quality materials" ],
                [ /materiali premium/gi, "premium materials" ],
                [ /finiture curate/gi, "refined craftsmanship" ],
                [ /eccellente comfort/gi, "excellent comfort" ],
                [ /stile unico/gi, "unique style" ],
                [ /collezione esclusiva/gi, "exclusive collection" ],
                [ /ad alte prestazioni/gi, "high performance" ],
                [ /alta qualità/gi, "high quality" ],
                [ /spedizione rapida/gi, "fast shipping" ],
                [ /edizione limitata/gi, "limited edition" ],
                [ /resistente e leggero/gi, "durable and lightweight" ],
                [ /traspirante/gi, "breathable" ]
            ],
            fr: [
                [ /scopri le straordinarie caratteristiche/gi, "découvrez les caractéristiques exceptionnelles" ],
                [ /design premium/gi, "design haut de gamme" ],
                [ /prodotto esclusivo/gi, "produit exclusif" ],
                [ /prodotto premium hyperdrip/gi, "produit premium Hyperdrip" ],
                [ /materiali di elevata qualità/gi, "matériaux de haute qualité" ],
                [ /materiali premium/gi, "matériaux haut de gamme" ],
                [ /finiture curate/gi, "finitions soignées" ],
                [ /eccellente comfort/gi, "confort exceptionnel" ],
                [ /stile unico/gi, "style unique" ],
                [ /collezione esclusiva/gi, "collection exclusive" ],
                [ /ad alte prestazioni/gi, "haute performance" ],
                [ /alta qualità/gi, "haute qualité" ],
                [ /spedizione rapida/gi, "livraison rapide" ],
                [ /edizione limitata/gi, "édition limitée" ]
            ],
            es: [
                [ /scopri le straordinarie caratteristiche/gi, "descubre las increíbles características" ],
                [ /design premium/gi, "diseño premium" ],
                [ /prodotto esclusivo/gi, "producto exclusivo" ],
                [ /prodotto premium hyperdrip/gi, "producto premium Hyperdrip" ],
                [ /materiali di elevata qualità/gi, "materiales de alta calidad" ],
                [ /materiali premium/gi, "materiales premium" ],
                [ /finiture curate/gi, "acabados cuidados" ],
                [ /eccellente comfort/gi, "excelente comodidad" ],
                [ /stile unico/gi, "estilo único" ],
                [ /collezione esclusiva/gi, "colección exclusiva" ],
                [ /ad alte prestazioni/gi, "de alto rendimiento" ],
                [ /alta calidad/gi, "alta calidad" ],
                [ /spedizione rapida/gi, "envío rápido" ],
                [ /edizione limitata/gi, "edición limitada" ]
            ],
            de: [
                [ /scopri le straordinarie caratteristiche/gi, "entdecken Sie die außergewöhnlichen Merkmale" ],
                [ /design premium/gi, "Premium-Design" ],
                [ /prodotto esclusivo/gi, "exklusives Produkt" ],
                [ /prodotto premium hyperdrip/gi, "Hyperdrip Premium-Produkt" ],
                [ /materiali di elevata qualità/gi, "hochwertige Materialien" ],
                [ /materiali premium/gi, "Premium-Materialien" ],
                [ /finiture curate/gi, "sorgfältige Verarbeitung" ],
                [ /eccellente comfort/gi, "hervorragender Komfort" ],
                [ /stile unico/gi, "einzigartiger Stil" ],
                [ /collezione esclusiva/gi, "exklusive Kollektion" ],
                [ /ad alte prestazioni/gi, "High-Performance" ],
                [ /alta qualità/gi, "hohe Qualität" ],
                [ /spedizione rapida/gi, "schneller Versand" ],
                [ /edizione limitata/gi, "limitierte Auflage" ]
            ]
        };

        const defaultDescFallbackByLang = {
            it: "Prodotto premium Hyperdrip realizzato con materiali di elevata qualità, finiture curate ed eccellente comfort per uno stile unico.",
            en: "Hyperdrip premium product crafted with high quality materials, refined details, and excellent comfort for a unique style.",
            fr: "Produit haut de gamme Hyperdrip conçu avec des matériaux de qualité supérieure, un confort exceptionnel et un style unique.",
            es: "Producto premium Hyperdrip elaborado con materiales de alta calidad, excelente comodidad y un estilo exclusivo.",
            de: "Hyperdrip Premium-Produkt aus hochwertigen Materialien, hervorragendem Komfort und exklusivem Stil."
        };

        document.querySelectorAll('[data-i18n-desc]').forEach(elem => {
            if (!elem.dataset.origDesc) {
                elem.dataset.origDesc = elem.textContent.trim();
            }
            const orig = elem.dataset.origDesc;
            if (!orig || orig.length === 0) return;

            if (lang === 'it') {
                elem.textContent = orig;
                return;
            }

            if (descTranslationsMap[orig] && descTranslationsMap[orig][lang]) {
                elem.textContent = descTranslationsMap[orig][lang];
            } else {
                let textToTranslate = orig;
                let isReplaced = false;
                if (phraseReplacements[lang]) {
                    phraseReplacements[lang].forEach(([regex, replacement]) => {
                        if (regex.test(textToTranslate)) {
                            isReplaced = true;
                            textToTranslate = textToTranslate.replace(regex, replacement);
                        }
                    });
                }

                if (isReplaced) {
                    elem.textContent = textToTranslate;
                } else {
                    elem.textContent = defaultDescFallbackByLang[lang] || orig;
                }
            }
        });
    }

    // Language Dropdown Event Handlers
    const langWrapper = document.getElementById('lang-selector-wrapper');
    const langBtn = document.getElementById('lang-selector-btn');

    if (langWrapper && langBtn) {
        langBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            const isOpen = langWrapper.classList.contains('open');
            langWrapper.classList.toggle('open', !isOpen);
            langBtn.setAttribute('aria-expanded', !isOpen);
        });

        document.querySelectorAll('.lang-option').forEach(option => {
            option.addEventListener('click', function(e) {
                e.stopPropagation();
                const selectedLang = this.dataset.lang;
                setLanguage(selectedLang);
                langWrapper.classList.remove('open');
                langBtn.setAttribute('aria-expanded', 'false');
            });
        });

        document.addEventListener('click', function(e) {
            if (!langWrapper.contains(e.target)) {
                langWrapper.classList.remove('open');
                langBtn.setAttribute('aria-expanded', 'false');
            }
        });
    }

    // Initialize Language
    setLanguage(currentLanguage);

    // 2. Hero Carousel Logic
    const slides = document.querySelectorAll('.carousel-slide');
    const indicators = document.querySelectorAll('.carousel-indicators .dot');
    let currentIndex = 0;

    if (slides.length > 0) {
        window.moveCarousel = function(direction) {
            slides[currentIndex].classList.remove('active');
            if(indicators[currentIndex]) indicators[currentIndex].classList.remove('active');
            
            currentIndex = (currentIndex + direction + slides.length) % slides.length;
            
            slides[currentIndex].classList.add('active');
            if(indicators[currentIndex]) indicators[currentIndex].classList.add('active');
        };

        window.goToSlide = function(index) {
            slides[currentIndex].classList.remove('active');
            if(indicators[currentIndex]) indicators[currentIndex].classList.remove('active');
            
            currentIndex = index;
            
            slides[currentIndex].classList.add('active');
            if(indicators[currentIndex]) indicators[currentIndex].classList.add('active');
        };

        setInterval(() => {
            if (slides.length > 1) moveCarousel(1);
        }, 5000);
    }

    // 3. Variant Selector Logic
    const optionPills = document.querySelectorAll('.option-pill');
    optionPills.forEach(pill => {
        pill.addEventListener('click', function(e) {
            e.preventDefault();
            const group = this.closest('.variant-option-group');
            if (!group) return;

            group.querySelectorAll('.option-pill').forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            const selectedValText = group.querySelector('.selected-value-text');
            if (selectedValText) {
                selectedValText.textContent = this.dataset.value;
            }

            updateSelectedVariant();
        });
    });

    function updateSelectedVariant() {
        const productForm = document.querySelector('.shopify-product-form[data-product-id]');
        if (!productForm) return;

        const productId = productForm.dataset.productId;
        const variantsScript = document.getElementById(`product-variants-json-${productId}`);
        if (!variantsScript) return;

        let variants = [];
        try {
            variants = JSON.parse(variantsScript.textContent);
        } catch (err) {
            console.error('Failed to parse product variants JSON:', err);
            return;
        }

        const selectedOptions = [];
        const groups = document.querySelectorAll('.variant-option-group');
        groups.forEach(group => {
            const activePill = group.querySelector('.option-pill.active');
            if (activePill) {
                selectedOptions.push(activePill.dataset.value);
            }
        });

        const matchedVariant = variants.find(variant => {
            return variant.options.every((optValue, index) => {
                return selectedOptions[index] === optValue;
            });
        });

        const variantIdInput = document.getElementById('selected-variant-id');
        const priceElem = document.getElementById('product-price');
        const comparePriceElem = document.getElementById('compare-price');
        const stockBadge = document.getElementById('stock-badge');
        const addToCartBtn = document.getElementById('add-to-cart-btn');
        const addToCartText = document.getElementById('add-to-cart-text');
        const buyNowBtn = document.getElementById('buy-now-btn');
        const buyNowText = document.getElementById('buy-now-text');
        const mainImg = document.getElementById('main-product-image');

        if (matchedVariant) {
            if (variantIdInput) variantIdInput.value = matchedVariant.id;

            if (priceElem) {
                priceElem.textContent = formatMoney(matchedVariant.price);
            }

            if (comparePriceElem) {
                if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
                    comparePriceElem.textContent = formatMoney(matchedVariant.compare_at_price);
                    comparePriceElem.style.display = 'inline';
                } else {
                    comparePriceElem.style.display = 'none';
                }
            }

            const dictionary = TRANSLATIONS[currentLanguage] || TRANSLATIONS.it;

            if (isVariantAvailable(matchedVariant)) {
                if (stockBadge) {
                    stockBadge.textContent = dictionary.in_stock;
                    stockBadge.className = 'stock-badge in-stock';
                }
                if (addToCartBtn) addToCartBtn.removeAttribute('disabled');
                if (addToCartText) addToCartText.textContent = dictionary.add_to_cart;
                if (buyNowBtn) {
                    buyNowBtn.removeAttribute('disabled');
                    if (buyNowText) buyNowText.textContent = dictionary.buy_now;
                }
            } else {
                if (stockBadge) {
                    stockBadge.textContent = dictionary.out_of_stock;
                    stockBadge.className = 'stock-badge out-of-stock';
                }
                if (addToCartBtn) addToCartBtn.setAttribute('disabled', 'disabled');
                if (addToCartText) addToCartText.textContent = dictionary.out_of_stock;
                if (buyNowBtn) {
                    buyNowBtn.setAttribute('disabled', 'disabled');
                    if (buyNowText) buyNowText.textContent = dictionary.out_of_stock;
                }
            }

            if (matchedVariant.featured_image && matchedVariant.featured_image.src && mainImg) {
                mainImg.src = matchedVariant.featured_image.src;
            }
        }
    }

    // 4. AJAX Add to Cart Form Handler
    document.addEventListener('submit', function(e) {
        const form = e.target;
        if (form.action && form.action.includes('/cart/add')) {
            e.preventDefault();

            const formData = new FormData(form);
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            })
            .then(res => {
                if (!res.ok) throw new Error('Cart add failed');
                return res.json();
            })
            .then(() => {
                const dict = TRANSLATIONS[currentLanguage] || TRANSLATIONS.it;
                showToast(dict.toast_added);
                updateCartCountBadge();
            })
            .catch(err => {
                console.warn('AJAX cart add fallback to standard submit:', err);
                form.submit();
            });
        }
    });

    function updateCartCountBadge() {
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            const countElem = document.getElementById('cart-count');
            if (countElem) {
                countElem.textContent = cart.item_count;
            }
        })
        .catch(() => {
            const remaining = document.querySelectorAll('.cart-item');
            let total = 0;
            remaining.forEach(item => {
                const input = item.querySelector('.cart-qty-input');
                total += input ? (parseInt(input.value) || 0) : 0;
            });
            const countElem = document.getElementById('cart-count');
            if (countElem && remaining.length > 0) {
                countElem.textContent = total;
            }
        });
    }

    function showToast(message) {
        const toast = document.getElementById('toast');
        if (toast) {
            toast.textContent = message;
            toast.classList.add('show');
            setTimeout(() => {
                toast.classList.remove('show');
            }, 3500);
        }
    }
});
